import { createSelector, createSlice } from "@reduxjs/toolkit"
import { notifiesService } from "../../services/book/notifies"
import { normalizeMessages } from "../../../packs/widgets/utils/parsers/messages"
import { departamentsService } from "../../services/admin/departaments"

const initialState = {
  list: [],
  options: [],
  default: null,
}

const departamentsSlice = createSlice({
  name: "departaments",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addMatcher(
      departamentsService.endpoints.getDepartaments.matchFulfilled,
      (state, action) => {
        if (action.payload) {
          if (action.payload && Array.isArray(action.payload)) {
            state.options = action.payload.map((item) => ({ key: item.id, value: item.name }))
          }
          state.list = action.payload
          state.default = action.payload[0].id
        } else {
          state.options = []
          state.list = []
        }
      }
    )
  },
})

const selectDepartamentsState = (state) => state.departaments

export const {} = departamentsSlice.actions

export const selectDepartaments = createSelector(
  [selectDepartamentsState],
  (state) => state.departaments
)

export const selectDepartamentsOptions = createSelector(
  [selectDepartamentsState],
  (state) => state.options
)

export const selectDepartamentsList = createSelector(
  [selectDepartamentsState],
  (state) => state.list
)

export const selectDefaultDepartament = createSelector(
  [selectDepartamentsState],
  (state) => state.default
)

export default departamentsSlice.reducer
